// covered-by: frontends/carrie/src/config/__tests__/askRouteTree.test.ts
// covered-by: frontends/carrie/src/ask-v2/routes/__tests__/pageRoutes.test.ts
import { askV2AskHomeRoute } from "./routes/askHomeRoute";
import { askV2AuthLayoutRoute } from "./routes/authLayout";
import { askV2ChatRoute } from "./routes/chatRoute";
import { askV2ChatsRoute } from "./routes/chatsRoute";
import { askV2IndexRoute } from "./routes/indexRoute";
import { askV2ProjectRoute } from "./routes/projectRoute";
import { askV2ProjectsRoute } from "./routes/projectsRoute";

import { forgotPasswordRoute } from "../routes/forgot-password/route";
import { loginRoute } from "../routes/login/route";
import { logoutRoute } from "../routes/logout/route";
import { resetPasswordRoute } from "../routes/reset-password/route";
import { unauthLayoutRoute } from "../routes/unauth-layout/route";

/**
 * Authenticated V2 pages. Static `ask-puntt/projects` and `ask-puntt/chats`
 * are registered before `ask-puntt/$chatId` so the param does not swallow
 * those segments.
 */
export const askV2AuthenticatedRoutes = [
  askV2IndexRoute,
  askV2AskHomeRoute,
  askV2ProjectsRoute,
  askV2ProjectRoute,
  askV2ChatsRoute,
  askV2ChatRoute,
];

/**
 * Top-level children of rootRoute when the Ask host gate is on.
 *
 * Login is reused (same WorkOS view) so `loginRoute.useSearch()` keeps working.
 * Tickets / V1 Ask Puntt / PunttLayout are intentionally omitted.
 */
export const askV2ChildRoutes = [
  unauthLayoutRoute.addChildren([
    loginRoute,
    forgotPasswordRoute,
    resetPasswordRoute,
  ]),
  logoutRoute,
  askV2AuthLayoutRoute.addChildren(askV2AuthenticatedRoutes),
];
